"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nrule = exports.ngen = exports.shared = exports.ngtw = exports.metadata = exports.form = exports.common = exports.priority = exports.odbcclient = exports.wcfclient = void 0;
var wcfclient = require("./wcfclient");
exports.wcfclient = wcfclient;
var odbcclient = require("./odbcclient");
exports.odbcclient = odbcclient;
var nform_1 = require("./nform");
Object.defineProperty(exports, "priority", { enumerable: true, get: function () { return nform_1.priority; } });
Object.defineProperty(exports, "common", { enumerable: true, get: function () { return nform_1.common; } });
var form = nform_1.priority.netitems.form;
exports.form = form;
var metadata = nform_1.priority.netitems.metadata;
exports.metadata = metadata;
var ngtw = nform_1.priority.netitems.ngtw;
exports.ngtw = ngtw;
var shared = nform_1.priority.netitems.shared;
exports.shared = shared;
var ngen = nform_1.priority.netitems.ngen;
exports.ngen = ngen;
var nrule = nform_1.priority.netitems.nrule;
exports.nrule = nrule;
